export default "__VITE_ASSET__Dahyfxww__"